import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccountGuard } from './core/guards/account.guard';
import { NotFoundComponent } from './core/not-found/not-found.component';
import { ServerErrorComponent } from './core/server-error/server-error.component';

const routes: Routes = [
  {
    path: 'account-portal',
    canActivate: [AccountGuard],
    loadChildren: () => import('./admin/admin.module').then((m) => m.AdminModule),
  },
  {
    // `/admin` mount, matching the admin-panel convention. Serves /admin/audit-log.
    // AccountGuard only requires a signed-in user — it applies no permission check here.
    path: 'admin',
    canActivate: [AccountGuard],
    loadChildren: () => import('./admin/admin.module').then((m) => m.AdminModule),
  },
  { path: 'auth', loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule) },
  { path: 'error/:code', component: ServerErrorComponent },
  { path: 'not-found', component: NotFoundComponent },
  { path: '', redirectTo: 'account-portal', pathMatch: 'full' },
  { path: '**', redirectTo: 'not-found' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
